export default [
  {
    name: 'importacao-registros',
    path: '/importacao-registros',
    component: () => import('@/app-modulo/comuns/bulk-operations/BulkRecordOperations.vue'),
    meta: {
      resource: 'importacaoregistros',
      action: 'read',
      pageTitle: 'Importação de Registros',
      breadcrumb: [],
    },
  },
]
